import { render, staticRenderFns } from "./SetupNoBrandContent.vue?vue&type=template&id=0e2fddb6&scoped=true"
import script from "./SetupNoBrandContent.vue?vue&type=script&lang=js"
export * from "./SetupNoBrandContent.vue?vue&type=script&lang=js"
import style0 from "./SetupNoBrandContent.vue?vue&type=style&index=0&id=0e2fddb6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2fddb6",
  null
  
)

export default component.exports